module.exports = __webpack_public_path__ + "img/bg_m.f1859164.jpg";